/**
 * Represents the action's type
 */
export const enum ActionType {
  CreateObject = 'createObject',
  UpdateObject = 'updateObject',
  DeleteObject = 'deleteObject',
  DeleteMultiObject = 'deleteMultiObject',
  Navigate = 'navigate',
  Logout = 'logout',
  SignUp = 'signup',
  SignIn = 'signin',
  ForgotPassword = 'forgotPassword',
  SetInputValue = 'setInputValue',
  PushNotification = 'pushNotification',
  ExternalLink = 'externalLink',
  Custom = 'custom',
  LineLogin = 'lineLogin',
  DocomoLogin = 'docomoLogin',
  DIDLogin = 'DIDLogin',
  TrustdockLogin = 'trustdockLogin',
  AppleLogin = 'appleLogin',
  SendMail = 'sendMail',
  TrackingAnalytic = 'googleAnalyticsEvent',
  CancelUnivaPaySubscription = 'cancelUnivaPaySubscription',
}
